var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6981",
    "data-name": "Group 6981",
    xmlns: "http://www.w3.org/2000/svg",
    width: 283.197,
    height: 64.355,
    viewBox: "0 0 283.197 64.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6958",
    "data-name": "Group 6958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6578",
    "data-name": "Rectangle 6578",
    d: "M0,0H16.061a0,0,0,0,1,0,0V48.293a0,0,0,0,1,0,0h0A16.061,16.061,0,0,1,0,32.232V0A0,0,0,0,1,0,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6579",
    "data-name": "Rectangle 6579",
    d: "M16.061,0h0a0,0,0,0,1,0,0V29.4a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V16.061A16.061,16.061,0,0,1,16.061,0Z",
    transform: "translate(16.061 64.355) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6580",
    "data-name": "Rectangle 6580",
    width: 26.168,
    height: 16.061,
    transform: "translate(11.006 16.061)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6959",
    "data-name": "Group 6959",
    transform: "translate(63.481 15.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M1607.5,247.76h-11.535v-5.712h30.279v5.712h-11.535v33.107H1607.5Z",
    transform: "translate(-1595.964 -240.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M1668.1,276.713h-20.685c.111,4.436,3.105,7.708,7.431,7.708,3.383,0,6.211-1.941,6.765-4.825l5.99.5c-.61,5.49-5.879,9.539-12.755,9.539-8.318,0-14.308-6.1-14.308-14.752,0-8.6,5.768-14.807,14.086-14.807,7.93,0,13.642,5.934,13.642,14.419A16.141,16.141,0,0,1,1668.1,276.713Zm-6.544-4.27a6.968,6.968,0,0,0-7.043-7.265c-3.938,0-6.877,2.939-7.1,7.265Z",
    transform: "translate(-1615.585 -248.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M1697.4,274.883c0-8.706,6.044-14.807,14.751-14.807,7.6,0,13.2,4.714,13.586,11.48l-6.544.5a6.719,6.719,0,0,0-7.042-6.156c-4.658,0-7.875,3.716-7.875,8.984,0,5.213,3.217,8.929,7.875,8.929,3.937,0,6.821-2.551,7.1-6.211l6.544.5c-.333,6.821-5.934,11.535-13.642,11.535C1703.445,289.635,1697.4,283.534,1697.4,274.883Z",
    transform: "translate(-1640.614 -248.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M1781.764,263.786v17.08h-6.821V264.729c0-4.381-2.107-6.877-5.767-6.877-3.937,0-6.211,2.884-6.211,8.1v14.918h-6.821V242.048h6.821v16.525a8.534,8.534,0,0,1,8.541-6.266C1777.771,252.307,1781.764,256.8,1781.764,263.786Z",
    transform: "translate(-1666.472 -240.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M1814.187,257.642h-5.046v-5.324h5.046v-2.163a9.264,9.264,0,0,1,9.316-9.594,14.854,14.854,0,0,1,3.494.333v5.435a10.069,10.069,0,0,0-2.107-.222c-2.662,0-3.882,1.553-3.882,4.049v2.163h5.768v5.324h-5.768v22.57h-6.821Z",
    transform: "translate(-1689.8 -240.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M1844.7,274.883a14.835,14.835,0,1,1,14.807,14.752A14.5,14.5,0,0,1,1844.7,274.883Zm22.737,0c0-5.324-3.216-9.039-7.93-9.039-4.658,0-7.931,3.715-7.931,9.039s3.272,8.984,7.931,8.984C1864.223,283.867,1867.44,280.207,1867.44,274.883Z",
    transform: "translate(-1705.454 -248.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M1905.526,271.565a27.7,27.7,0,0,1,.721-5.324l5.879-26.176,6.488,1.331-5.879,26.175a13.792,13.792,0,0,0-.388,2.884c0,2.5,1.775,4.215,4.547,4.215a4.955,4.955,0,0,0,1.5-.166l-1.054,5.545a12.961,12.961,0,0,1-2.329.222C1909.463,280.271,1905.526,276.667,1905.526,271.565Z",
    transform: "translate(-1732.227 -240.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M1955.684,263.675l10.7,17.192h-7.431l-7.82-12.81-4.769,4.492v8.318H1939.6V242.048h6.765v22.293l12.2-11.369h8.374Z",
    transform: "translate(-1747.227 -240.938)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9024d556.svg";
export { ForwardRef as ReactComponent };